.portalBanner {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 20px;
	width: 100%;
	height: auto;
	min-height: max-content;
	padding: 11px 16px;
	font-size: 15px;
	font-weight: 400;
	color: black;
	border-radius: 7px;
	transition:
		max-height 0.3s ease,
		margin 0.3s ease,
		padding 0.3s ease,
		border-color 0.3s ease;
	transform: scaleY(1);
	transform-origin: center;
	visibility: visible;

	&.primary {
		background: #f9f8ff;
		border: 2px solid #c0b9ec;
		filter: drop-shadow(0 5px 5px #6c69701a);

		& .portalInfoIcon {
			color: #42296e;
		}
	}

	&.secondary {
		border: 2px solid #0b6f85;
		background-color: #eefbfe;

		& .portalInfoIcon {
			color: #0b6f85;
		}
	}

	&.success {
		border: 2px solid #d4f4da;
		background-color: #f9fffa;
	}
}

.portalBannerClosed {
	max-height: 0;
	padding-top: 0;
	padding-bottom: 0;
	margin-top: 0;
	margin-bottom: 0;
	transform: scaleY(0);
	visibility: hidden;
}

.portalBannerChildren {
	display: flex;
	align-items: center;
	width: 100%;
	gap: 10px;
	transition:
		transform 0.3s ease,
		opacity 0.3s ease;
	transform: scaleY(1);
	opacity: 1;
}

.portalBannerClosed .portalBannerChildren {
	transform: scaleY(0);
	opacity: 0;
}

.portalBannerBody {
	display: flex;
	align-items: center;
	gap: 10px;
}

.portalInfoIcon {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
}

.portalBannerText {
	text-align: left;
}

.successIconWrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	flex-shrink: 0;
	background-color: #e3f8e6;
	border-radius: 9.17px;
}

.successCircle {
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1.67px solid #05883a;
	border-radius: 50%;
	flex-shrink: 0;
	width: 18px;
	height: 18px;

	& svg {
		color: #05883a;
	}
}

@media (max-width: 700px) {
	.portalBanner {
		align-items: start;
	}

	.portalBannerBody {
		align-items: start;
	}

	.portalInfoIcon {
		margin-top: 2.5px;
	}
}
